import moment from 'moment';

export const phoneFormatter = {
  filters: {
    phone(value) {
      /**
       * Formats a phone number.
       * E.g. 1234567890 => (123) 456-7890
       */
      return value.replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
  },
};